import "./CaseOfficerServiceEvaluation.scss"
import { CaseOfficerServiceProvider } from "../../features/CaseOfficerServiceForm/ServiceContext";
import ServiceReviewForm from "../../features/CaseOfficerServiceForm/ServiceReviewForm";
const CaseOfficerServiceEvaluation = () => {
  return (
    <CaseOfficerServiceProvider >
      <div className="page-container">
        <ServiceReviewForm />
      </div>
    </CaseOfficerServiceProvider >
  );
};
export default CaseOfficerServiceEvaluation;
